(function () {
  var stateByCard = new WeakMap();

  function closestCard(element) {
    return element ? element.closest("product-card, .product-card, .sp-card") : null;
  }

  function primaryImage(card) {
    return card ? card.querySelector("img.product-card__image--primary, img.sp-card__img:not(.sp-card__img--hover)") : null;
  }

  function containsTarget(container, target) {
    return Boolean(container && target && target.nodeType && container.contains(target));
  }

  function attrState(element, name) {
    return {
      name: name,
      has: element.hasAttribute(name),
      value: element.getAttribute(name)
    };
  }

  function restoreAttr(element, saved) {
    if (!element || !saved) return;

    if (saved.has) {
      element.setAttribute(saved.name, saved.value);
    } else {
      element.removeAttribute(saved.name);
    }
  }

  function saveOriginal(card, image) {
    var picture = image.closest("picture");
    var sources = picture ? Array.prototype.slice.call(picture.querySelectorAll("source")) : [];

    stateByCard.set(card, {
      image: image,
      imageAttrs: [
        attrState(image, "src"),
        attrState(image, "srcset"),
        attrState(image, "sizes")
      ],
      sources: sources.map(function (source) {
        return {
          element: source,
          attrs: [
            attrState(source, "srcset"),
            attrState(source, "sizes")
          ]
        };
      })
    });
  }

  function preview(link) {
    var card = closestCard(link);
    var image = primaryImage(card);
    var previewImage = link.getAttribute("data-preview-image");
    var previewSrcset = link.getAttribute("data-preview-srcset");

    if (!card || !image || !previewImage) return;

    if (!stateByCard.has(card) || stateByCard.get(card).image !== image) {
      saveOriginal(card, image);
    }

    card.classList.add("is-color-previewing");

    if (previewSrcset) {
      image.setAttribute("srcset", previewSrcset);
    } else {
      image.removeAttribute("srcset");
    }

    image.setAttribute("src", previewImage);

    var picture = image.closest("picture");
    if (picture) {
      Array.prototype.slice.call(picture.querySelectorAll("source")).forEach(function (source) {
        if (previewSrcset) {
          source.setAttribute("srcset", previewSrcset);
        } else {
          source.removeAttribute("srcset");
        }
      });
    }
  }

  function restore(card) {
    var state = stateByCard.get(card);
    if (!state) return;

    var image = state.image && state.image.isConnected ? state.image : primaryImage(card);
    if (image) {
      state.imageAttrs.forEach(function (saved) {
        restoreAttr(image, saved);
      });
    }

    state.sources.forEach(function (sourceState) {
      if (!sourceState.element || !sourceState.element.isConnected) return;

      sourceState.attrs.forEach(function (saved) {
        restoreAttr(sourceState.element, saved);
      });
    });

    card.classList.remove("is-color-previewing");
    stateByCard.delete(card);
  }

  document.addEventListener("pointerover", function (event) {
    var link = event.target.closest(".card-color-swatches__link");
    if (link) preview(link);
  });

  document.addEventListener("focusin", function (event) {
    var link = event.target.closest(".card-color-swatches__link");
    if (link) preview(link);
  });

  document.addEventListener("pointerout", function (event) {
    var card = closestCard(event.target);

    if (card && !containsTarget(card, event.relatedTarget)) {
      restore(card);
      return;
    }

    var wrapper = event.target.closest(".card-color-swatches-wrapper");
    if (wrapper && !containsTarget(wrapper, event.relatedTarget)) {
      restore(closestCard(wrapper));
    }
  });

  document.addEventListener("focusout", function (event) {
    var card = closestCard(event.target);
    var wrapper = event.target.closest(".card-color-swatches-wrapper");

    window.requestAnimationFrame(function () {
      if (wrapper && !containsTarget(wrapper, document.activeElement)) {
        restore(closestCard(wrapper));
      } else if (card && !containsTarget(card, document.activeElement)) {
        restore(card);
      }
    });
  });
})();
